import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useProgress } from '../contexts/ProgressContext';
import { useNavigate } from 'react-router-dom';
import Downloads from '../components/Downloads';
import TelegramWidget from '../components/TelegramWidget';
import './Dashboard.css';

const Resources = () => {
  const { user, isAuthenticated, logout } = useAuth();
  const { progress } = useProgress();
  const navigate = useNavigate();

  if (!isAuthenticated) {
    navigate('/login');
    return null;
  }

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const totalProgress = progress?.totalProgress || 0;

  return (
    <div className="dashboard-layout">
      <aside className="dashboard-sidebar">
        <div className="sidebar-logo" onClick={() => navigate('/dashboard')}>
          <span className="logo-text">F12IA</span>
          <span className="logo-tm">™</span>
        </div>

        <div className="sidebar-user">
          <div className="user-avatar">
            {user?.firstName?.charAt(0).toUpperCase() || 'U'}
          </div>
          <div className="user-info">
            <span className="user-name">{user?.firstName || 'Utilisateur'}</span>
            <span className="user-role">Membre PRO</span>
          </div>
        </div>

        <nav className="sidebar-nav-pro">
          <div className="nav-label">MENU</div>
          <div className="nav-item" onClick={() => navigate('/dashboard')}>
            <span className="nav-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg></span>
            <span className="nav-text">Tableau de bord</span>
          </div>

          <div className="nav-label">FORMATIONS</div>
          <div className="nav-item" onClick={() => navigate('/formation/chatgpt')}>
            <span className="nav-icon chatgpt-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729z"/></svg></span>
            <span className="nav-text">ChatGPT</span>
          </div>
          <div className="nav-item" onClick={() => navigate('/formation/claude')}>
            <span className="nav-icon claude-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M4.709 15.955l4.72-2.647.08-.23-.08-.128-2.251-3.614-.144-.072-4.794.893-.071.158.503 2.332.014.13 2.023 3.178z"/></svg></span>
            <span className="nav-text">Claude Code</span>
          </div>
          <div className="nav-item fusion-nav" onClick={() => navigate('/formation/fusion')}>
            <span className="nav-icon fusion-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M13 10V3L4 14h7v7l9-11h-7z"/></svg></span>
            <span className="nav-text">Fusion</span>
            <span className="nav-badge-pro">PRO</span>
          </div>

          <div className="nav-label">COMPTE</div>
          <div className="nav-item" onClick={() => navigate('/profile')}>
            <span className="nav-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/></svg></span>
            <span className="nav-text">Mon profil</span>
          </div>
          <div className="nav-item" onClick={() => navigate('/settings')}>
            <span className="nav-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/></svg></span>
            <span className="nav-text">Paramètres</span>
          </div>
          <div className="nav-item active" onClick={() => navigate('/resources')}>
            <span className="nav-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg></span>
            <span className="nav-text">Ressources</span>
          </div>
          <div className="nav-item" onClick={() => navigate('/certificate')}>
            <span className="nav-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="6"/><path d="M8 14l-2 8 6-3 6 3-2-8"/></svg></span>
            <span className="nav-text">Certificat</span>
          </div>
        </nav>

        <div className="sidebar-progress-pro">
          <div className="progress-header">
            <span className="progress-title">Progression</span>
            <span className="progress-value">{Math.round(totalProgress)}%</span>
          </div>
          <div className="progress-bar-pro">
            <div className="progress-fill-pro" style={{ width: `${totalProgress}%` }} />
          </div>
        </div>

        <div className="sidebar-bottom">
          <div className="nav-item logout-item" onClick={handleLogout}>
            <span className="nav-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg></span>
            <span className="nav-text">Déconnexion</span>
          </div>
        </div>
      </aside>

      <main className="dashboard-main">
        <div className="dashboard-topbar">
          <div className="topbar-left">
            <h1 className="page-title">Ressources</h1>
          </div>
          <div className="topbar-right">
            <span className="welcome-text">Bienvenue, <strong>{user?.firstName}</strong></span>
          </div>
        </div>

        <div className="dashboard-content">
          <Downloads />

          <div className="resources-community-section">
            <h2 className="section-title-resources">Rejoignez la communauté</h2>
            <p className="section-desc-resources">
              Posez vos questions, partagez vos projets, et échangez avec les autres membres.
            </p>
            <TelegramWidget />
          </div>

          <div className="resources-certificate-section">
            <h2 className="section-title-resources">Votre Certificat</h2>
            <p className="section-desc-resources">
              Complétez tous les parcours avec un score minimum de 70% aux quiz pour débloquer votre certificat F12IA.
            </p>
            <button className="btn btn-primary" onClick={() => navigate('/certificate')}>
              Voir mon certificat
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Resources;
